/**
 * Shinohara Intensity Ratio Indicator
 *
 * Wraps the shinohara calculator and merges results into chart data.
 * Outputs two ratios:
 * - weakRatio: Intraday weakness (High-Close vs Close-Low)
 * - strongRatio: Interday strength (High-PrevClose vs PrevClose-Low)
 */

import { rebind, merge } from "../utils";
import { shinohara } from "../calculator";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "Shinohara";

export default function () {
  const base = baseIndicator()
    .type(ALGORITHM_TYPE)
    .accessor((d) => d.shinohara);

  const underlyingAlgorithm = shinohara();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      datum.shinohara = indicator;
    });

  const indicator = function (data, options = { merge: true }) {
    if (options.merge) {
      if (!base.accessor())
        throw new Error(
          `Set an accessor to ${ALGORITHM_TYPE} before calculating`,
        );
      return mergedAlgorithm(data);
    }
    return underlyingAlgorithm(data);
  };

  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "options", "undefinedLength");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
